<template>
  <div class="wrapper">
    <side-bar>
      <template v-if="admin.id_role === 1 || admin.id_role === 2">
        <sidebar-link to="/admin/overview">
          <p><i class="bi bi-house-fill"></i>Inicio</p>
        </sidebar-link>
      </template>
      <template v-if="admin.id_role === 1 || admin.id_role === 2">
        <sidebar-link to="/admin/members">
          <p><i class="bi bi-person-rolodex"></i>Agremiados</p>
        </sidebar-link>
        <sidebar-link to="/admin/promotions">
          <p><i class="bi bi-bag-fill"></i>Promociones</p>
        </sidebar-link>
        <sidebar-link to="/admin/monthly-payments">
          <p><i class="bi bi-cash-coin"></i>Mensualidades</p>
        </sidebar-link>
        <sidebar-link to="/admin/banks">
          <p><i class="bi bi-bank"></i>Bancos CILARA</p>
        </sidebar-link>
        <sidebar-link to="/admin/mails">
          <p><i class="bi bi-envelope-fill"></i>Correos</p>
        </sidebar-link>
        <sidebar-link to="/admin/variables">
          <p><i class="bi bi-file-earmark-text"></i>Carta de Solicitud</p>
        </sidebar-link>
        <sidebar-link to="/admin/settings">
          <p><i class="bi bi-gear-fill"></i>Configuraciones</p>
        </sidebar-link>
      </template>

      <template v-if="admin.id_role === 1">
        <sidebar-link to="/admin/administrators">
          <p><i class="bi bi-person-fill"></i>Administradores</p>
        </sidebar-link>
      </template>

      <template v-if="admin.id_role === 3 || admin.id_role === 1">
        <sidebar-link to="/admin/events">
          <p><i class="bi bi-list-ul"></i>Eventos</p>
        </sidebar-link>
        <sidebar-link to="/admin/news">
          <p><i class="bi bi-newspaper"></i>Noticias</p>
        </sidebar-link>
      </template>

      <template slot="bottom-links">
        <a
          class="d-flex justify-content-center text-white"
          @click.prevent="openLink"
          style="cursor: pointer"
        >
          <p style="font-size: 0.8rem">Desarrollado por Ticktaps</p>
        </a>
      </template>
      <mobile-menu></mobile-menu>
    </side-bar>
    <div class="main-panel">
      <top-navbar></top-navbar>
      <dashboard-content @click="toggleSidebar"></dashboard-content>
    </div>
  </div>
</template>

<script>
import Cookies from 'js-cookie'
import TopNavbar from './TopNavbar.vue'
import DashboardContent from './Content.vue'
import MobileMenu from './MobileMenu.vue'
import { mapActions } from 'vuex'

export default {
  name: 'DashboardLayout',
  data() {
    return {
      admin: {
        id_role: 0
      }
    }
  },
  components: {
    TopNavbar,
    DashboardContent,
    MobileMenu
  },

  mounted() {
    this.getElement(Cookies.get('id'))
  },

  methods: {
    ...mapActions(['getData']),
    getElement(id) {
      this.getData({ url: `admin/${id}` })
        .then((response) => {
          if (response.code === 200) {
            this.admin = response.data
          }
        })
        .catch((error) => {
          console.error(error)
        })
    },
    toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false)
      }
    },
    openLink() {
      window.open('https://www.ticktaps.com/', '_blank')
    }
  }
}
</script>
